import { container } from "tsyringe";
import type { IEditorSettingsRepository } from "$src/domain/designs/settings/IEditorSettingsRepository";
import { EditorSettingsRepository } from "./designs/settings/EditorSettingsRepository";
import { ICustomerRepository } from "$src/domain/customers/ICustomerRepository";
import { CustomerRepositoryApi } from "./customers/CustomerRepositoryApi";
import { UserRepositoryApi } from "./users/UserRepositoryApi";
import { IUserRepository } from "$src/domain/users/IUserRepository";
import { SearchRepositoryApi } from "./searches/SearchRepositoryApi";
import { ISearchRepository } from "$src/domain/searches/ISearchRepository";
import { DocumentRepositoryApi } from "./projects/documents/DocumentRepositoryApi";
import { IDocumentRepository } from "$src/domain/projects/documents/IDocumentRepository";
import { ServiceTokens } from "$src/domain/ServiceTokens";
import { IProjectRepository } from "$src/domain/projects/IProjectRepository";
import { ProjectRepositoryApi } from "./projects/ProjectRepositoryApi";
import { IProjectDraftRepository } from "$src/domain/projects/drafts/IProjectDraftRepository";
import { ProjectDraftRepositoryApi } from "./projects/drafts/ProjectDraftRepositoryApi";
import { IDeliveryRepository } from "$src/domain/projects/deliveries/IDeliveryRepository";
import { DeliveryRepositoryApi } from "./projects/deliveries/DeliveryRepositoryApi";
import { ILocalityRepository } from "$src/domain/map/ILocalityRepository";
import { LocalityRepositoryApi } from "./map/LocalityRepositoryApi";
import { IStoreRepository } from "$src/domain/directory/stores/IStoreRepository";
import { StoreRepositoryApi } from "./directory/stores/StoreRepositoryApi";
import { ReportRepositoryApi } from "./reporting/ReportRepositoryApi";
import { IReportRepository } from "$src/domain/reporting/IReportRepository";

container.register<IEditorSettingsRepository>("IEditorSettingsRepository", { useClass: EditorSettingsRepository });
container.register<IUserRepository>(ServiceTokens.UserRepository, { useClass: UserRepositoryApi });
container.register<ICustomerRepository>(ServiceTokens.CustomerRepository, { useClass: CustomerRepositoryApi });
container.register<ISearchRepository>(ServiceTokens.SearchRepository, { useClass: SearchRepositoryApi });
container.register<IProjectRepository>(ServiceTokens.ProjectService, { useClass: ProjectRepositoryApi });
container.register<IProjectDraftRepository>(ServiceTokens.ProjectDraftRepository, { useClass: ProjectDraftRepositoryApi });
container.register<IDocumentRepository>(ServiceTokens.DocumentRepository, { useClass: DocumentRepositoryApi });
container.register<IDeliveryRepository>(ServiceTokens.DeliveryRepository, { useClass: DeliveryRepositoryApi });
container.register<ILocalityRepository>(ServiceTokens.LocalityRepository, { useClass: LocalityRepositoryApi });
container.register<IStoreRepository>(ServiceTokens.StoreRepository, { useClass: StoreRepositoryApi });
container.register<IReportRepository>(ServiceTokens.ReportRepository, { useClass: ReportRepositoryApi });

